import { Button } from "@/components/ui/button"
import { DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu"
import { availableChains, CHAIN, getChainConfig } from "@/lib/chains"
import { cn } from "@/lib/utils"
import { enableChain } from "@/lib/web3/chains"
import { DropdownMenu, DropdownMenuTrigger } from "@radix-ui/react-dropdown-menu"
import { ChevronDown, Unplug } from "lucide-react"
import Image from "next/image"
import { toast } from "sonner"
import { formatUnits } from "viem"
import { useAccount, useBalance, useChainId, useWalletClient } from "wagmi"

export const NetworkSelector = () => {

    const walletClient = useWalletClient()
    const chainId = useChainId()

    const {address: userAddress} = useAccount()
    const {data} = useBalance({address: userAddress })
    const displayBalance = Number(formatUnits(BigInt(data?.value ?? 0), data?.decimals ?? 18))?.toFixed(2) 
  


    const setChain = async (chainId: number) => {
        const config = getChainConfig(chainId)
        toast.info(`Switching to ${config.name}…`)
        await enableChain(config.config, walletClient)
        toast.success(`You\'re on ${config.name}!`)
      }

    return  <DropdownMenu>
    <DropdownMenuTrigger
      asChild
      className="max-sm:hidden"
    >
      <Button
        variant={'outline'}
        className={'h-10 pl-3 bg-card'}
      >
        {availableChains.includes(chainId) ? <Image
          className={`rounded-full object-cover size-5`}
          src={getChainConfig(chainId).iconUrl}
          alt={'alt'}
          width={22}
          height={22}
        /> : <Unplug/>}
        <p className={' text-sm pl-1'}>{displayBalance}</p>
        <ChevronDown />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent className={'bg-background !w-28 min-w-4'}>
      {availableChains.map((chain: CHAIN) => {
        const config = getChainConfig(chain)

        return (
          <DropdownMenuItem
            key={chain}
            className={cn('hover:bg-card')}
            onClick={() => setChain(chain)}
          >
            <Image
              className={'rounded-full object-cover size-5'}
              src={config.iconUrl}
              alt={`${config.name} chain icon`}
              width={22}
              height={22}
            />
            {config.name}
          </DropdownMenuItem>
        )
      })}
    </DropdownMenuContent>
  </DropdownMenu>
}